<syn-checkbox-title title="Assigner des évaluations" />

@for (assessment of assessments; track assessment) {
<div class="d-flex align-items-center">
  <div class="form-check">
    <input
      class="form-check-input"
      type="checkbox"
      [id]="assessment.id"
      (change)="onCheckAssessment($event, assessment)" />
    <label class="form-check-label" [for]="assessment.id">
      {{ assessment.name }}
      @if (assessment.isCertifying) {
      <syn-certified-assessment-icon />
      }
    </label>
  </div>
  <span
    class="material-symbols-outlined text-primary ms-auto align-items-center"
    data-toggle="tooltip"
    data-placement="right"
    [title]="assessment.description"
    >info
  </span>
</div>
} @if (!assessments) {
<div>
  <ngb-progressbar type="primary" [value]="100" [striped]="true" [animated]="true">Loading...</ngb-progressbar>
</div>
}
